/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ForcePasswordResetRouteImport } from './routes/force-password-reset'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedTrainingNeedsRouteImport } from './routes/_authenticated/training-needs'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCertificatePreviewRouteImport } from './routes/_authenticated/certificate-preview'
import { Route as MembershipApplyRouteRouteImport } from './routes/membership/apply/route'
import { Route as MembershipApplyIndexRouteImport } from './routes/membership/apply/index'
import { Route as AuthenticatedMembershipIndexRouteImport } from './routes/_authenticated/membership/index'
import { Route as MembershipApplyReviewRouteImport } from './routes/membership/apply/review'
import { Route as MembershipApplyRequirementsRouteImport } from './routes/membership/apply/requirements'
import { Route as MembershipApplyProfileRouteImport } from './routes/membership/apply/profile'
import { Route as MembershipApplyEmploymentRouteImport } from './routes/membership/apply/employment'
import { Route as MembershipApplyEducationRouteImport } from './routes/membership/apply/education'
import { Route as MembershipApplyDocumentsRouteImport } from './routes/membership/apply/documents'
import { Route as MembershipApplyCategoryRouteImport } from './routes/membership/apply/category'
import { Route as MembershipApplyAffiliationsRouteImport } from './routes/membership/apply/affiliations'
import { Route as AuthenticatedSettingsRequirementsRouteImport } from './routes/_authenticated/settings/requirements'
import { Route as AuthenticatedSettingsCategoriesRouteImport } from './routes/_authenticated/settings/categories'
import { Route as AuthenticatedSettingsBenefitsConfigRouteImport } from './routes/_authenticated/settings/benefits-config'
import { Route as AuthenticatedMembershipRenewalsRouteImport } from './routes/_authenticated/membership/renewals'
import { Route as AuthenticatedMembershipRenewRouteImport } from './routes/_authenticated/membership/renew'
import { Route as AuthenticatedMembershipProfileRouteImport } from './routes/_authenticated/membership/profile'
import { Route as AuthenticatedMembershipApplicationsRouteImport } from './routes/_authenticated/membership/applications'
import { Route as AuthenticatedBenefitsOverviewRouteImport } from './routes/_authenticated/benefits/overview'
import { Route as AuthenticatedBenefitsDocumentsRouteImport } from './routes/_authenticated/benefits/documents'
import { Route as AuthenticatedBenefitsCpdBankRouteImport } from './routes/_authenticated/benefits/cpd-bank'
import { Route as AuthenticatedBenefitsCalendarRouteImport } from './routes/_authenticated/benefits/calendar'
import { Route as AuthenticatedAdminTrainingNeedsRouteImport } from './routes/_authenticated/admin/training-needs'
import { Route as AuthenticatedAdminReportsRouteImport } from './routes/_authenticated/admin/reports'
import { Route as AuthenticatedAdminRenewalsRouteImport } from './routes/_authenticated/admin/renewals'
import { Route as AuthenticatedAdminInsightsRouteImport } from './routes/_authenticated/admin/insights'
import { Route as AuthenticatedAdminCpdRegistrationsRouteImport } from './routes/_authenticated/admin/cpd-registrations'
import { Route as AuthenticatedAdminBirthdaysRouteImport } from './routes/_authenticated/admin/birthdays'
import { Route as AuthenticatedAdminApprovedApplicationsRouteImport } from './routes/_authenticated/admin/approved-applications'
import { Route as AuthenticatedAdminApplicationsRouteImport } from './routes/_authenticated/admin/applications'
import { Route as AuthenticatedBenefitsCommunitiesIndexRouteImport } from './routes/_authenticated/benefits/communities/index'
import { Route as AuthenticatedBenefitsCommunitiesCommunityIdRouteImport } from './routes/_authenticated/benefits/communities/$communityId'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ForcePasswordResetRoute = ForcePasswordResetRouteImport.update({
  id: '/force-password-reset',
  path: '/force-password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTrainingNeedsRoute =
  AuthenticatedTrainingNeedsRouteImport.update({
    id: '/training-needs',
    path: '/training-needs',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCertificatePreviewRoute =
  AuthenticatedCertificatePreviewRouteImport.update({
    id: '/certificate-preview',
    path: '/certificate-preview',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const MembershipApplyRouteRoute = MembershipApplyRouteRouteImport.update({
  id: '/membership/apply',
  path: '/membership/apply',
  getParentRoute: () => rootRouteImport,
} as any)
const MembershipApplyIndexRoute = MembershipApplyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MembershipApplyRouteRoute,
} as any)
const AuthenticatedMembershipIndexRoute =
  AuthenticatedMembershipIndexRouteImport.update({
    id: '/membership/',
    path: '/membership/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const MembershipApplyReviewRoute = MembershipApplyReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => MembershipApplyRouteRoute,
} as any)
const MembershipApplyRequirementsRoute =
  MembershipApplyRequirementsRouteImport.update({
    id: '/requirements',
    path: '/requirements',
    getParentRoute: () => MembershipApplyRouteRoute,
  } as any)
const MembershipApplyProfileRoute = MembershipApplyProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => MembershipApplyRouteRoute,
} as any)
const MembershipApplyEmploymentRoute =
  MembershipApplyEmploymentRouteImport.update({
    id: '/employment',
    path: '/employment',
    getParentRoute: () => MembershipApplyRouteRoute,
  } as any)
const MembershipApplyEducationRoute =
  MembershipApplyEducationRouteImport.update({
    id: '/education',
    path: '/education',
    getParentRoute: () => MembershipApplyRouteRoute,
  } as any)
const MembershipApplyDocumentsRoute =
  MembershipApplyDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => MembershipApplyRouteRoute,
  } as any)
const MembershipApplyCategoryRoute = MembershipApplyCategoryRouteImport.update({
  id: '/category',
  path: '/category',
  getParentRoute: () => MembershipApplyRouteRoute,
} as any)
const MembershipApplyAffiliationsRoute =
  MembershipApplyAffiliationsRouteImport.update({
    id: '/affiliations',
    path: '/affiliations',
    getParentRoute: () => MembershipApplyRouteRoute,
  } as any)
const AuthenticatedSettingsRequirementsRoute =
  AuthenticatedSettingsRequirementsRouteImport.update({
    id: '/settings/requirements',
    path: '/settings/requirements',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsCategoriesRoute =
  AuthenticatedSettingsCategoriesRouteImport.update({
    id: '/settings/categories',
    path: '/settings/categories',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsBenefitsConfigRoute =
  AuthenticatedSettingsBenefitsConfigRouteImport.update({
    id: '/settings/benefits-config',
    path: '/settings/benefits-config',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMembershipRenewalsRoute =
  AuthenticatedMembershipRenewalsRouteImport.update({
    id: '/membership/renewals',
    path: '/membership/renewals',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMembershipRenewRoute =
  AuthenticatedMembershipRenewRouteImport.update({
    id: '/membership/renew',
    path: '/membership/renew',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMembershipProfileRoute =
  AuthenticatedMembershipProfileRouteImport.update({
    id: '/membership/profile',
    path: '/membership/profile',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMembershipApplicationsRoute =
  AuthenticatedMembershipApplicationsRouteImport.update({
    id: '/membership/applications',
    path: '/membership/applications',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBenefitsOverviewRoute =
  AuthenticatedBenefitsOverviewRouteImport.update({
    id: '/benefits/overview',
    path: '/benefits/overview',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBenefitsDocumentsRoute =
  AuthenticatedBenefitsDocumentsRouteImport.update({
    id: '/benefits/documents',
    path: '/benefits/documents',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBenefitsCpdBankRoute =
  AuthenticatedBenefitsCpdBankRouteImport.update({
    id: '/benefits/cpd-bank',
    path: '/benefits/cpd-bank',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBenefitsCalendarRoute =
  AuthenticatedBenefitsCalendarRouteImport.update({
    id: '/benefits/calendar',
    path: '/benefits/calendar',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminTrainingNeedsRoute =
  AuthenticatedAdminTrainingNeedsRouteImport.update({
    id: '/admin/training-needs',
    path: '/admin/training-needs',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminReportsRoute =
  AuthenticatedAdminReportsRouteImport.update({
    id: '/admin/reports',
    path: '/admin/reports',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminRenewalsRoute =
  AuthenticatedAdminRenewalsRouteImport.update({
    id: '/admin/renewals',
    path: '/admin/renewals',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminInsightsRoute =
  AuthenticatedAdminInsightsRouteImport.update({
    id: '/admin/insights',
    path: '/admin/insights',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminCpdRegistrationsRoute =
  AuthenticatedAdminCpdRegistrationsRouteImport.update({
    id: '/admin/cpd-registrations',
    path: '/admin/cpd-registrations',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminBirthdaysRoute =
  AuthenticatedAdminBirthdaysRouteImport.update({
    id: '/admin/birthdays',
    path: '/admin/birthdays',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminApprovedApplicationsRoute =
  AuthenticatedAdminApprovedApplicationsRouteImport.update({
    id: '/admin/approved-applications',
    path: '/admin/approved-applications',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAdminApplicationsRoute =
  AuthenticatedAdminApplicationsRouteImport.update({
    id: '/admin/applications',
    path: '/admin/applications',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBenefitsCommunitiesIndexRoute =
  AuthenticatedBenefitsCommunitiesIndexRouteImport.update({
    id: '/benefits/communities/',
    path: '/benefits/communities/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBenefitsCommunitiesCommunityIdRoute =
  AuthenticatedBenefitsCommunitiesCommunityIdRouteImport.update({
    id: '/benefits/communities/$communityId',
    path: '/benefits/communities/$communityId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/force-password-reset': typeof ForcePasswordResetRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/membership/apply': typeof MembershipApplyRouteRouteWithChildren
  '/certificate-preview': typeof AuthenticatedCertificatePreviewRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/training-needs': typeof AuthenticatedTrainingNeedsRoute
  '/admin/applications': typeof AuthenticatedAdminApplicationsRoute
  '/admin/approved-applications': typeof AuthenticatedAdminApprovedApplicationsRoute
  '/admin/birthdays': typeof AuthenticatedAdminBirthdaysRoute
  '/admin/cpd-registrations': typeof AuthenticatedAdminCpdRegistrationsRoute
  '/admin/insights': typeof AuthenticatedAdminInsightsRoute
  '/admin/renewals': typeof AuthenticatedAdminRenewalsRoute
  '/admin/reports': typeof AuthenticatedAdminReportsRoute
  '/admin/training-needs': typeof AuthenticatedAdminTrainingNeedsRoute
  '/benefits/calendar': typeof AuthenticatedBenefitsCalendarRoute
  '/benefits/cpd-bank': typeof AuthenticatedBenefitsCpdBankRoute
  '/benefits/documents': typeof AuthenticatedBenefitsDocumentsRoute
  '/benefits/overview': typeof AuthenticatedBenefitsOverviewRoute
  '/membership/applications': typeof AuthenticatedMembershipApplicationsRoute
  '/membership/profile': typeof AuthenticatedMembershipProfileRoute
  '/membership/renew': typeof AuthenticatedMembershipRenewRoute
  '/membership/renewals': typeof AuthenticatedMembershipRenewalsRoute
  '/settings/benefits-config': typeof AuthenticatedSettingsBenefitsConfigRoute
  '/settings/categories': typeof AuthenticatedSettingsCategoriesRoute
  '/settings/requirements': typeof AuthenticatedSettingsRequirementsRoute
  '/membership/apply/affiliations': typeof MembershipApplyAffiliationsRoute
  '/membership/apply/category': typeof MembershipApplyCategoryRoute
  '/membership/apply/documents': typeof MembershipApplyDocumentsRoute
  '/membership/apply/education': typeof MembershipApplyEducationRoute
  '/membership/apply/employment': typeof MembershipApplyEmploymentRoute
  '/membership/apply/profile': typeof MembershipApplyProfileRoute
  '/membership/apply/requirements': typeof MembershipApplyRequirementsRoute
  '/membership/apply/review': typeof MembershipApplyReviewRoute
  '/membership': typeof AuthenticatedMembershipIndexRoute
  '/membership/apply/': typeof MembershipApplyIndexRoute
  '/benefits/communities/$communityId': typeof AuthenticatedBenefitsCommunitiesCommunityIdRoute
  '/benefits/communities': typeof AuthenticatedBenefitsCommunitiesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/force-password-reset': typeof ForcePasswordResetRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/certificate-preview': typeof AuthenticatedCertificatePreviewRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/training-needs': typeof AuthenticatedTrainingNeedsRoute
  '/admin/applications': typeof AuthenticatedAdminApplicationsRoute
  '/admin/approved-applications': typeof AuthenticatedAdminApprovedApplicationsRoute
  '/admin/birthdays': typeof AuthenticatedAdminBirthdaysRoute
  '/admin/cpd-registrations': typeof AuthenticatedAdminCpdRegistrationsRoute
  '/admin/insights': typeof AuthenticatedAdminInsightsRoute
  '/admin/renewals': typeof AuthenticatedAdminRenewalsRoute
  '/admin/reports': typeof AuthenticatedAdminReportsRoute
  '/admin/training-needs': typeof AuthenticatedAdminTrainingNeedsRoute
  '/benefits/calendar': typeof AuthenticatedBenefitsCalendarRoute
  '/benefits/cpd-bank': typeof AuthenticatedBenefitsCpdBankRoute
  '/benefits/documents': typeof AuthenticatedBenefitsDocumentsRoute
  '/benefits/overview': typeof AuthenticatedBenefitsOverviewRoute
  '/membership/applications': typeof AuthenticatedMembershipApplicationsRoute
  '/membership/profile': typeof AuthenticatedMembershipProfileRoute
  '/membership/renew': typeof AuthenticatedMembershipRenewRoute
  '/membership/renewals': typeof AuthenticatedMembershipRenewalsRoute
  '/settings/benefits-config': typeof AuthenticatedSettingsBenefitsConfigRoute
  '/settings/categories': typeof AuthenticatedSettingsCategoriesRoute
  '/settings/requirements': typeof AuthenticatedSettingsRequirementsRoute
  '/membership/apply/affiliations': typeof MembershipApplyAffiliationsRoute
  '/membership/apply/category': typeof MembershipApplyCategoryRoute
  '/membership/apply/documents': typeof MembershipApplyDocumentsRoute
  '/membership/apply/education': typeof MembershipApplyEducationRoute
  '/membership/apply/employment': typeof MembershipApplyEmploymentRoute
  '/membership/apply/profile': typeof MembershipApplyProfileRoute
  '/membership/apply/requirements': typeof MembershipApplyRequirementsRoute
  '/membership/apply/review': typeof MembershipApplyReviewRoute
  '/membership': typeof AuthenticatedMembershipIndexRoute
  '/membership/apply': typeof MembershipApplyIndexRoute
  '/benefits/communities/$communityId': typeof AuthenticatedBenefitsCommunitiesCommunityIdRoute
  '/benefits/communities': typeof AuthenticatedBenefitsCommunitiesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/force-password-reset': typeof ForcePasswordResetRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/membership/apply': typeof MembershipApplyRouteRouteWithChildren
  '/_authenticated/certificate-preview': typeof AuthenticatedCertificatePreviewRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/training-needs': typeof AuthenticatedTrainingNeedsRoute
  '/_authenticated/admin/applications': typeof AuthenticatedAdminApplicationsRoute
  '/_authenticated/admin/approved-applications': typeof AuthenticatedAdminApprovedApplicationsRoute
  '/_authenticated/admin/birthdays': typeof AuthenticatedAdminBirthdaysRoute
  '/_authenticated/admin/cpd-registrations': typeof AuthenticatedAdminCpdRegistrationsRoute
  '/_authenticated/admin/insights': typeof AuthenticatedAdminInsightsRoute
  '/_authenticated/admin/renewals': typeof AuthenticatedAdminRenewalsRoute
  '/_authenticated/admin/reports': typeof AuthenticatedAdminReportsRoute
  '/_authenticated/admin/training-needs': typeof AuthenticatedAdminTrainingNeedsRoute
  '/_authenticated/benefits/calendar': typeof AuthenticatedBenefitsCalendarRoute
  '/_authenticated/benefits/cpd-bank': typeof AuthenticatedBenefitsCpdBankRoute
  '/_authenticated/benefits/documents': typeof AuthenticatedBenefitsDocumentsRoute
  '/_authenticated/benefits/overview': typeof AuthenticatedBenefitsOverviewRoute
  '/_authenticated/membership/applications': typeof AuthenticatedMembershipApplicationsRoute
  '/_authenticated/membership/profile': typeof AuthenticatedMembershipProfileRoute
  '/_authenticated/membership/renew': typeof AuthenticatedMembershipRenewRoute
  '/_authenticated/membership/renewals': typeof AuthenticatedMembershipRenewalsRoute
  '/_authenticated/settings/benefits-config': typeof AuthenticatedSettingsBenefitsConfigRoute
  '/_authenticated/settings/categories': typeof AuthenticatedSettingsCategoriesRoute
  '/_authenticated/settings/requirements': typeof AuthenticatedSettingsRequirementsRoute
  '/membership/apply/affiliations': typeof MembershipApplyAffiliationsRoute
  '/membership/apply/category': typeof MembershipApplyCategoryRoute
  '/membership/apply/documents': typeof MembershipApplyDocumentsRoute
  '/membership/apply/education': typeof MembershipApplyEducationRoute
  '/membership/apply/employment': typeof MembershipApplyEmploymentRoute
  '/membership/apply/profile': typeof MembershipApplyProfileRoute
  '/membership/apply/requirements': typeof MembershipApplyRequirementsRoute
  '/membership/apply/review': typeof MembershipApplyReviewRoute
  '/_authenticated/membership/': typeof AuthenticatedMembershipIndexRoute
  '/membership/apply/': typeof MembershipApplyIndexRoute
  '/_authenticated/benefits/communities/$communityId': typeof AuthenticatedBenefitsCommunitiesCommunityIdRoute
  '/_authenticated/benefits/communities/': typeof AuthenticatedBenefitsCommunitiesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/force-password-reset'
    | '/forgot-password'
    | '/login'
    | '/not-found'
    | '/reset-password'
    | '/signup'
    | '/membership/apply'
    | '/certificate-preview'
    | '/dashboard'
    | '/notifications'
    | '/training-needs'
    | '/admin/applications'
    | '/admin/approved-applications'
    | '/admin/birthdays'
    | '/admin/cpd-registrations'
    | '/admin/insights'
    | '/admin/renewals'
    | '/admin/reports'
    | '/admin/training-needs'
    | '/benefits/calendar'
    | '/benefits/cpd-bank'
    | '/benefits/documents'
    | '/benefits/overview'
    | '/membership/applications'
    | '/membership/profile'
    | '/membership/renew'
    | '/membership/renewals'
    | '/settings/benefits-config'
    | '/settings/categories'
    | '/settings/requirements'
    | '/membership/apply/affiliations'
    | '/membership/apply/category'
    | '/membership/apply/documents'
    | '/membership/apply/education'
    | '/membership/apply/employment'
    | '/membership/apply/profile'
    | '/membership/apply/requirements'
    | '/membership/apply/review'
    | '/membership'
    | '/membership/apply/'
    | '/benefits/communities/$communityId'
    | '/benefits/communities'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/force-password-reset'
    | '/forgot-password'
    | '/login'
    | '/not-found'
    | '/reset-password'
    | '/signup'
    | '/certificate-preview'
    | '/dashboard'
    | '/notifications'
    | '/training-needs'
    | '/admin/applications'
    | '/admin/approved-applications'
    | '/admin/birthdays'
    | '/admin/cpd-registrations'
    | '/admin/insights'
    | '/admin/renewals'
    | '/admin/reports'
    | '/admin/training-needs'
    | '/benefits/calendar'
    | '/benefits/cpd-bank'
    | '/benefits/documents'
    | '/benefits/overview'
    | '/membership/applications'
    | '/membership/profile'
    | '/membership/renew'
    | '/membership/renewals'
    | '/settings/benefits-config'
    | '/settings/categories'
    | '/settings/requirements'
    | '/membership/apply/affiliations'
    | '/membership/apply/category'
    | '/membership/apply/documents'
    | '/membership/apply/education'
    | '/membership/apply/employment'
    | '/membership/apply/profile'
    | '/membership/apply/requirements'
    | '/membership/apply/review'
    | '/membership'
    | '/membership/apply'
    | '/benefits/communities/$communityId'
    | '/benefits/communities'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/force-password-reset'
    | '/forgot-password'
    | '/login'
    | '/not-found'
    | '/reset-password'
    | '/signup'
    | '/membership/apply'
    | '/_authenticated/certificate-preview'
    | '/_authenticated/dashboard'
    | '/_authenticated/notifications'
    | '/_authenticated/training-needs'
    | '/_authenticated/admin/applications'
    | '/_authenticated/admin/approved-applications'
    | '/_authenticated/admin/birthdays'
    | '/_authenticated/admin/cpd-registrations'
    | '/_authenticated/admin/insights'
    | '/_authenticated/admin/renewals'
    | '/_authenticated/admin/reports'
    | '/_authenticated/admin/training-needs'
    | '/_authenticated/benefits/calendar'
    | '/_authenticated/benefits/cpd-bank'
    | '/_authenticated/benefits/documents'
    | '/_authenticated/benefits/overview'
    | '/_authenticated/membership/applications'
    | '/_authenticated/membership/profile'
    | '/_authenticated/membership/renew'
    | '/_authenticated/membership/renewals'
    | '/_authenticated/settings/benefits-config'
    | '/_authenticated/settings/categories'
    | '/_authenticated/settings/requirements'
    | '/membership/apply/affiliations'
    | '/membership/apply/category'
    | '/membership/apply/documents'
    | '/membership/apply/education'
    | '/membership/apply/employment'
    | '/membership/apply/profile'
    | '/membership/apply/requirements'
    | '/membership/apply/review'
    | '/_authenticated/membership/'
    | '/membership/apply/'
    | '/_authenticated/benefits/communities/$communityId'
    | '/_authenticated/benefits/communities/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  ForcePasswordResetRoute: typeof ForcePasswordResetRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  NotFoundRoute: typeof NotFoundRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  MembershipApplyRouteRoute: typeof MembershipApplyRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/force-password-reset': {
      id: '/force-password-reset'
      path: '/force-password-reset'
      fullPath: '/force-password-reset'
      preLoaderRoute: typeof ForcePasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/training-needs': {
      id: '/_authenticated/training-needs'
      path: '/training-needs'
      fullPath: '/training-needs'
      preLoaderRoute: typeof AuthenticatedTrainingNeedsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/certificate-preview': {
      id: '/_authenticated/certificate-preview'
      path: '/certificate-preview'
      fullPath: '/certificate-preview'
      preLoaderRoute: typeof AuthenticatedCertificatePreviewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/membership/apply': {
      id: '/membership/apply'
      path: '/membership/apply'
      fullPath: '/membership/apply'
      preLoaderRoute: typeof MembershipApplyRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/membership/apply/': {
      id: '/membership/apply/'
      path: '/'
      fullPath: '/membership/apply/'
      preLoaderRoute: typeof MembershipApplyIndexRouteImport
      parentRoute: typeof MembershipApplyRouteRoute
    }
    '/_authenticated/membership/': {
      id: '/_authenticated/membership/'
      path: '/membership'
      fullPath: '/membership'
      preLoaderRoute: typeof AuthenticatedMembershipIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/membership/apply/review': {
      id: '/membership/apply/review'
      path: '/review'
      fullPath: '/membership/apply/review'
      preLoaderRoute: typeof MembershipApplyReviewRouteImport
      parentRoute: typeof MembershipApplyRouteRoute
    }
    '/membership/apply/requirements': {
      id: '/membership/apply/requirements'
      path: '/requirements'
      fullPath: '/membership/apply/requirements'
      preLoaderRoute: typeof MembershipApplyRequirementsRouteImport
      parentRoute: typeof MembershipApplyRouteRoute
    }
    '/membership/apply/profile': {
      id: '/membership/apply/profile'
      path: '/profile'
      fullPath: '/membership/apply/profile'
      preLoaderRoute: typeof MembershipApplyProfileRouteImport
      parentRoute: typeof MembershipApplyRouteRoute
    }
    '/membership/apply/employment': {
      id: '/membership/apply/employment'
      path: '/employment'
      fullPath: '/membership/apply/employment'
      preLoaderRoute: typeof MembershipApplyEmploymentRouteImport
      parentRoute: typeof MembershipApplyRouteRoute
    }
    '/membership/apply/education': {
      id: '/membership/apply/education'
      path: '/education'
      fullPath: '/membership/apply/education'
      preLoaderRoute: typeof MembershipApplyEducationRouteImport
      parentRoute: typeof MembershipApplyRouteRoute
    }
    '/membership/apply/documents': {
      id: '/membership/apply/documents'
      path: '/documents'
      fullPath: '/membership/apply/documents'
      preLoaderRoute: typeof MembershipApplyDocumentsRouteImport
      parentRoute: typeof MembershipApplyRouteRoute
    }
    '/membership/apply/category': {
      id: '/membership/apply/category'
      path: '/category'
      fullPath: '/membership/apply/category'
      preLoaderRoute: typeof MembershipApplyCategoryRouteImport
      parentRoute: typeof MembershipApplyRouteRoute
    }
    '/membership/apply/affiliations': {
      id: '/membership/apply/affiliations'
      path: '/affiliations'
      fullPath: '/membership/apply/affiliations'
      preLoaderRoute: typeof MembershipApplyAffiliationsRouteImport
      parentRoute: typeof MembershipApplyRouteRoute
    }
    '/_authenticated/settings/requirements': {
      id: '/_authenticated/settings/requirements'
      path: '/settings/requirements'
      fullPath: '/settings/requirements'
      preLoaderRoute: typeof AuthenticatedSettingsRequirementsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/categories': {
      id: '/_authenticated/settings/categories'
      path: '/settings/categories'
      fullPath: '/settings/categories'
      preLoaderRoute: typeof AuthenticatedSettingsCategoriesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/benefits-config': {
      id: '/_authenticated/settings/benefits-config'
      path: '/settings/benefits-config'
      fullPath: '/settings/benefits-config'
      preLoaderRoute: typeof AuthenticatedSettingsBenefitsConfigRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/membership/renewals': {
      id: '/_authenticated/membership/renewals'
      path: '/membership/renewals'
      fullPath: '/membership/renewals'
      preLoaderRoute: typeof AuthenticatedMembershipRenewalsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/membership/renew': {
      id: '/_authenticated/membership/renew'
      path: '/membership/renew'
      fullPath: '/membership/renew'
      preLoaderRoute: typeof AuthenticatedMembershipRenewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/membership/profile': {
      id: '/_authenticated/membership/profile'
      path: '/membership/profile'
      fullPath: '/membership/profile'
      preLoaderRoute: typeof AuthenticatedMembershipProfileRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/membership/applications': {
      id: '/_authenticated/membership/applications'
      path: '/membership/applications'
      fullPath: '/membership/applications'
      preLoaderRoute: typeof AuthenticatedMembershipApplicationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/benefits/overview': {
      id: '/_authenticated/benefits/overview'
      path: '/benefits/overview'
      fullPath: '/benefits/overview'
      preLoaderRoute: typeof AuthenticatedBenefitsOverviewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/benefits/documents': {
      id: '/_authenticated/benefits/documents'
      path: '/benefits/documents'
      fullPath: '/benefits/documents'
      preLoaderRoute: typeof AuthenticatedBenefitsDocumentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/benefits/cpd-bank': {
      id: '/_authenticated/benefits/cpd-bank'
      path: '/benefits/cpd-bank'
      fullPath: '/benefits/cpd-bank'
      preLoaderRoute: typeof AuthenticatedBenefitsCpdBankRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/benefits/calendar': {
      id: '/_authenticated/benefits/calendar'
      path: '/benefits/calendar'
      fullPath: '/benefits/calendar'
      preLoaderRoute: typeof AuthenticatedBenefitsCalendarRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/training-needs': {
      id: '/_authenticated/admin/training-needs'
      path: '/admin/training-needs'
      fullPath: '/admin/training-needs'
      preLoaderRoute: typeof AuthenticatedAdminTrainingNeedsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/reports': {
      id: '/_authenticated/admin/reports'
      path: '/admin/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AuthenticatedAdminReportsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/renewals': {
      id: '/_authenticated/admin/renewals'
      path: '/admin/renewals'
      fullPath: '/admin/renewals'
      preLoaderRoute: typeof AuthenticatedAdminRenewalsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/insights': {
      id: '/_authenticated/admin/insights'
      path: '/admin/insights'
      fullPath: '/admin/insights'
      preLoaderRoute: typeof AuthenticatedAdminInsightsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/cpd-registrations': {
      id: '/_authenticated/admin/cpd-registrations'
      path: '/admin/cpd-registrations'
      fullPath: '/admin/cpd-registrations'
      preLoaderRoute: typeof AuthenticatedAdminCpdRegistrationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/birthdays': {
      id: '/_authenticated/admin/birthdays'
      path: '/admin/birthdays'
      fullPath: '/admin/birthdays'
      preLoaderRoute: typeof AuthenticatedAdminBirthdaysRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/approved-applications': {
      id: '/_authenticated/admin/approved-applications'
      path: '/admin/approved-applications'
      fullPath: '/admin/approved-applications'
      preLoaderRoute: typeof AuthenticatedAdminApprovedApplicationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin/applications': {
      id: '/_authenticated/admin/applications'
      path: '/admin/applications'
      fullPath: '/admin/applications'
      preLoaderRoute: typeof AuthenticatedAdminApplicationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/benefits/communities/': {
      id: '/_authenticated/benefits/communities/'
      path: '/benefits/communities'
      fullPath: '/benefits/communities'
      preLoaderRoute: typeof AuthenticatedBenefitsCommunitiesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/benefits/communities/$communityId': {
      id: '/_authenticated/benefits/communities/$communityId'
      path: '/benefits/communities/$communityId'
      fullPath: '/benefits/communities/$communityId'
      preLoaderRoute: typeof AuthenticatedBenefitsCommunitiesCommunityIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedCertificatePreviewRoute: typeof AuthenticatedCertificatePreviewRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedTrainingNeedsRoute: typeof AuthenticatedTrainingNeedsRoute
  AuthenticatedAdminApplicationsRoute: typeof AuthenticatedAdminApplicationsRoute
  AuthenticatedAdminApprovedApplicationsRoute: typeof AuthenticatedAdminApprovedApplicationsRoute
  AuthenticatedAdminBirthdaysRoute: typeof AuthenticatedAdminBirthdaysRoute
  AuthenticatedAdminCpdRegistrationsRoute: typeof AuthenticatedAdminCpdRegistrationsRoute
  AuthenticatedAdminInsightsRoute: typeof AuthenticatedAdminInsightsRoute
  AuthenticatedAdminRenewalsRoute: typeof AuthenticatedAdminRenewalsRoute
  AuthenticatedAdminReportsRoute: typeof AuthenticatedAdminReportsRoute
  AuthenticatedAdminTrainingNeedsRoute: typeof AuthenticatedAdminTrainingNeedsRoute
  AuthenticatedBenefitsCalendarRoute: typeof AuthenticatedBenefitsCalendarRoute
  AuthenticatedBenefitsCpdBankRoute: typeof AuthenticatedBenefitsCpdBankRoute
  AuthenticatedBenefitsDocumentsRoute: typeof AuthenticatedBenefitsDocumentsRoute
  AuthenticatedBenefitsOverviewRoute: typeof AuthenticatedBenefitsOverviewRoute
  AuthenticatedMembershipApplicationsRoute: typeof AuthenticatedMembershipApplicationsRoute
  AuthenticatedMembershipProfileRoute: typeof AuthenticatedMembershipProfileRoute
  AuthenticatedMembershipRenewRoute: typeof AuthenticatedMembershipRenewRoute
  AuthenticatedMembershipRenewalsRoute: typeof AuthenticatedMembershipRenewalsRoute
  AuthenticatedSettingsBenefitsConfigRoute: typeof AuthenticatedSettingsBenefitsConfigRoute
  AuthenticatedSettingsCategoriesRoute: typeof AuthenticatedSettingsCategoriesRoute
  AuthenticatedSettingsRequirementsRoute: typeof AuthenticatedSettingsRequirementsRoute
  AuthenticatedMembershipIndexRoute: typeof AuthenticatedMembershipIndexRoute
  AuthenticatedBenefitsCommunitiesCommunityIdRoute: typeof AuthenticatedBenefitsCommunitiesCommunityIdRoute
  AuthenticatedBenefitsCommunitiesIndexRoute: typeof AuthenticatedBenefitsCommunitiesIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedCertificatePreviewRoute: AuthenticatedCertificatePreviewRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedTrainingNeedsRoute: AuthenticatedTrainingNeedsRoute,
  AuthenticatedAdminApplicationsRoute: AuthenticatedAdminApplicationsRoute,
  AuthenticatedAdminApprovedApplicationsRoute:
    AuthenticatedAdminApprovedApplicationsRoute,
  AuthenticatedAdminBirthdaysRoute: AuthenticatedAdminBirthdaysRoute,
  AuthenticatedAdminCpdRegistrationsRoute:
    AuthenticatedAdminCpdRegistrationsRoute,
  AuthenticatedAdminInsightsRoute: AuthenticatedAdminInsightsRoute,
  AuthenticatedAdminRenewalsRoute: AuthenticatedAdminRenewalsRoute,
  AuthenticatedAdminReportsRoute: AuthenticatedAdminReportsRoute,
  AuthenticatedAdminTrainingNeedsRoute: AuthenticatedAdminTrainingNeedsRoute,
  AuthenticatedBenefitsCalendarRoute: AuthenticatedBenefitsCalendarRoute,
  AuthenticatedBenefitsCpdBankRoute: AuthenticatedBenefitsCpdBankRoute,
  AuthenticatedBenefitsDocumentsRoute: AuthenticatedBenefitsDocumentsRoute,
  AuthenticatedBenefitsOverviewRoute: AuthenticatedBenefitsOverviewRoute,
  AuthenticatedMembershipApplicationsRoute:
    AuthenticatedMembershipApplicationsRoute,
  AuthenticatedMembershipProfileRoute: AuthenticatedMembershipProfileRoute,
  AuthenticatedMembershipRenewRoute: AuthenticatedMembershipRenewRoute,
  AuthenticatedMembershipRenewalsRoute: AuthenticatedMembershipRenewalsRoute,
  AuthenticatedSettingsBenefitsConfigRoute:
    AuthenticatedSettingsBenefitsConfigRoute,
  AuthenticatedSettingsCategoriesRoute: AuthenticatedSettingsCategoriesRoute,
  AuthenticatedSettingsRequirementsRoute:
    AuthenticatedSettingsRequirementsRoute,
  AuthenticatedMembershipIndexRoute: AuthenticatedMembershipIndexRoute,
  AuthenticatedBenefitsCommunitiesCommunityIdRoute:
    AuthenticatedBenefitsCommunitiesCommunityIdRoute,
  AuthenticatedBenefitsCommunitiesIndexRoute:
    AuthenticatedBenefitsCommunitiesIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface MembershipApplyRouteRouteChildren {
  MembershipApplyAffiliationsRoute: typeof MembershipApplyAffiliationsRoute
  MembershipApplyCategoryRoute: typeof MembershipApplyCategoryRoute
  MembershipApplyDocumentsRoute: typeof MembershipApplyDocumentsRoute
  MembershipApplyEducationRoute: typeof MembershipApplyEducationRoute
  MembershipApplyEmploymentRoute: typeof MembershipApplyEmploymentRoute
  MembershipApplyProfileRoute: typeof MembershipApplyProfileRoute
  MembershipApplyRequirementsRoute: typeof MembershipApplyRequirementsRoute
  MembershipApplyReviewRoute: typeof MembershipApplyReviewRoute
  MembershipApplyIndexRoute: typeof MembershipApplyIndexRoute
}

const MembershipApplyRouteRouteChildren: MembershipApplyRouteRouteChildren = {
  MembershipApplyAffiliationsRoute: MembershipApplyAffiliationsRoute,
  MembershipApplyCategoryRoute: MembershipApplyCategoryRoute,
  MembershipApplyDocumentsRoute: MembershipApplyDocumentsRoute,
  MembershipApplyEducationRoute: MembershipApplyEducationRoute,
  MembershipApplyEmploymentRoute: MembershipApplyEmploymentRoute,
  MembershipApplyProfileRoute: MembershipApplyProfileRoute,
  MembershipApplyRequirementsRoute: MembershipApplyRequirementsRoute,
  MembershipApplyReviewRoute: MembershipApplyReviewRoute,
  MembershipApplyIndexRoute: MembershipApplyIndexRoute,
}

const MembershipApplyRouteRouteWithChildren =
  MembershipApplyRouteRoute._addFileChildren(MembershipApplyRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ForcePasswordResetRoute: ForcePasswordResetRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  NotFoundRoute: NotFoundRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  MembershipApplyRouteRoute: MembershipApplyRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
